import { HWKataToFWHira, FWKataToFWHira } from "./mapAlpha";

const fullWidthKana =
  "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョガギグゲゴザジズゼゾダヂヅデドバビブベボパピプペポ";
const fullWidthHiragana =
  "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわをんぁぃぅぇぉっゃゅょがぎぐげござじずぜぞだぢづでどばびぶべぼぱぴぷぺぽ";
const halfWidthKana =
  "ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟ";

export default function convertToHalfWidthKana(text) {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    let index = fullWidthKana.indexOf(text[i]);
    if (index === -1) {
      index = fullWidthHiragana.indexOf(text[i]);
    }
    if (index !== -1) {
      result += halfWidthKana[index];
    } else {
      result += text[i];
    }
  }
  return result;
}

export const convertToHiragana = (text) => {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    let char = text[i];
    if (HWKataToFWHira[char]) result += HWKataToFWHira[char];
    else if (FWKataToFWHira[char]) result += FWKataToFWHira[char];
    else result += char;
  }
  return result;
};
